module.exports = __webpack_public_path__ + "static/media/online_shop_administration.75227637.svg";